import React from 'react';
import MetaData from '../../layout/MetaData';
import '../../../css/Driver.css';
import Loader from '../../layout/Loader';
import { useGetDriverPaymentHistoryQuery, useAddDriverPaymentMutation } from '../../../redux/api/driverApi';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const Payment = () => {
  const user = useSelector((state) => state.auth.user);
  const { data, isLoading, isError } = useGetDriverPaymentHistoryQuery();
  const [addPayment, { isLoading: isPaying }] = useAddDriverPaymentMutation();

  if (isLoading) return <Loader />;
  if (isError) return <p>Error fetching payment history.</p>;

  const paymentHistory = data?.paymentHistory || [];
  const due = user?.payment?.mbzCut || 0;

  // --- Make MA Payment ---
  const handlePay = async () => {
    try {
      const res = await addPayment({
        totalEarned: user?.payment?.totalEarned,
        mbzCut: user?.payment?.mbzCut,
        driversCut: user?.payment?.driversCut,
      }).unwrap();

      if (res.success) {
        toast.success("✅ MA Payment initiated successfully!");
        console.log("📡 Easypaisa Response:", res.easypaisaResponse);
      } else {
        toast.error(res?.message || "❌ Failed to initiate payment");
      }
    } catch (error) {
      toast.error(error?.data?.message || "❌ Payment initiation failed!");
    }
  };

  return (
    <>
      <MetaData title="Driver Payment" />
      <div className="container py-5">
        <div className="row justify-content-center mb-5">
          <div className="col-md-8 col-lg-6 text-center p-4 bg-light rounded shadow">
            <h2 className="mb-3 text-primary fw-bold">💰 ادائیگی کی تفصیل</h2>
            <h5 className="text-secondary">ہمارے پیسے جو آپ کو ادا کرنے ہیں:</h5>
            <h1 className="my-3 text-danger fw-bold">{due} PKR</h1>

            <button
              className="btn btn-success btn-lg"
              onClick={handlePay}
              disabled={isPaying || due === 0}
            >
              {isPaying ? 'ادائیگی ہو رہی ہے...' : 'ہمارے پیسے دے'}
            </button>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <h3 className="mb-4 text-center fw-bold border-bottom pb-2">
              آپ کی پے منٹ ہسٹری
            </h3>
            {paymentHistory.length === 0 ? (
              <p className="text-center">پیمینٹ ہسٹری موجود نہیں ہے۔</p>
            ) : (
              <div className="table-responsive shadow-sm">
                <table className="table table-bordered table-striped align-middle">
                  <thead className="table-dark">
                    <tr>
                      <th>#</th>
                      <th>کل بُکنگ کی رقم</th>
                      <th>MBZ کٹ</th>
                      <th>ڈرائیور کی رقم</th>
                      <th>تاریخ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paymentHistory.map((entry, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>Rs. {entry.totalEarned}</td>
                        <td>Rs. {entry.mbzCut}</td>
                        <td>Rs. {entry.driversCut}</td>
                        <td>{new Date(entry.date).toLocaleString()}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Payment;
